import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const listMembership = catchAsync(async (locationId, search) => {
  let query = "";
  if (search) {
    query = query + "?search=" + search;
  }
  let url = `salon/${locationId}/memberships` + query;
  const { data } = await axiosInstance.get(url);
  return data;
});

export const showMembership = catchAsync(async (locationId, id) => {
  let url = `salon/${locationId}/memberships/` + id;
  const { data } = await axiosInstance.get(url, {
    headers: {
      "x-translations": true,
    },
  });
  return data;
});

export const addMembership = catchAsync(async (locationId, body) => {
  const data = await axiosInstance.post(
    `salon/${locationId}/memberships`,
    body
  );
  return data;
});

export const deleteMembership = catchAsync(async (locationId, membershipId) => {
  const { data } = await axiosInstance.delete(
    `salon/${locationId}/memberships/${membershipId}`
  );
  return data;
});

export const updateMembership = catchAsync(
  async (locationId, membershipId, body) => {
    const res = await axiosInstance.put(
      `salon/${locationId}/memberships/${membershipId}`,
      body
    );
    return res;
  }
);
